export default "/images/whatsapp.svg?2b3bcf8c00e5e8f58f10d825468d1db2";